import React, { ReactElement } from 'react';
import { Title, Box, Group, BoxProps, createPolymorphicComponent, Button, useMantineColorScheme } from '@mantine/core';

import { BreadCrumbs } from 'src/components/navigation/BreadCrumbs'
import { ResponsiveView } from 'src/components/ui/ResponsiveView'
import styled from 'styled-components'
import { Icons } from './Icons';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useLocation, useNavigate } from 'react-router-dom';

type DrawerPageHeaderProps = {
    title: string;
    badge?: ReactElement;
    renderAction?: ReactElement;
    preview?: ReactElement;
}

const _DrawerPageHeaderWrapper = styled(Box)`     
    display: flex;
    flex-direction: column;
    justify-content: center;
`
const DrawerPageHeaderWrapper = createPolymorphicComponent<'div', BoxProps>(_DrawerPageHeaderWrapper);

export const DrawerPageHeader: React.FC<DrawerPageHeaderProps> = ({ title, renderAction, badge, preview }) => {

    const { colorScheme } = useMantineColorScheme();
    const navigate = useNavigate();
    const location = useLocation();

    const onClose = () => {
        if (location.state?.drawerFrom) {
            navigate(location.state.drawerFrom, { replace: true });
        } else {
            navigate("..", { replace: true });
        }
    };

    return (
        <DrawerPageHeaderWrapper>
            <ResponsiveView
                renderDesktop={
                    <Box style={{ border: '0px solid red' }}>
                        <Group justify='space-between'>
                            <Group>
                                <Button
                                    onClick={onClose}
                                    color={colorScheme === 'light' ? 'dark' : 'gray'}
                                    variant="light"
                                    size="sm"
                                    px={8}
                                >
                                    <Icon icon={Icons.back} width={19} />
                                </Button>
                                <Box>
                                    <BreadCrumbs />
                                    <Group gap="xs">
                                        <Title order={2} style={{ lineHeight: '30px' }}>{title}</Title>
                                        {badge}
                                    </Group>
                                </Box>
                            </Group>
                            {renderAction}
                        </Group>
                        {preview}
                    </Box>
                }
                renderMobile={
                    <Box>
                        <Group justify='space-between'>
                            <Group gap="xs">
                                <Button
                                    onClick={onClose}
                                    color={colorScheme === 'light' ? 'dark' : 'gray'}
                                    variant="light"
                                    size="sm"
                                    px={8}
                                >
                                    <Icon icon={Icons.back} width={19} />
                                </Button>
                                <Group>
                                    <Title order={2} style={theme => ({ fontSize: theme.fontSizes.lg })}>{title}</Title>
                                    {badge}
                                </Group>
                            </Group>
                            {renderAction}
                        </Group>
                    </Box>
                }
            />
        </DrawerPageHeaderWrapper>
    )
}